import React from 'react';
import { Grid2, TextField } from '@mui/material';

function TwitterForm({ values, setFieldValue }) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label="X (Twitter) Pixel ID"
                    value={values.settings?.trackingId || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            trackingId: ev.target.value,
                        })
                    }
                    placeholder="xxxxx"
                    helperText="Enter your X (Twitter) Pixel ID"
                />
            </Grid2>
        </>
    );
}

export default TwitterForm;
